import { useEffect } from 'react';
import { useQuery } from 'react-query';
import { useGlobalContext, useRepository } from '@context';
import { Serializer } from '@common/utils';
import { IUserInfo } from '@common/interfaces';

const useUserInfo = (): IUserInfo => {
  const { accountRepository } = useRepository();

  const { userInfo, setUserInfo } = useGlobalContext();

  const { data } = useQuery('get-user', () => accountRepository.getUser(), {
    refetchOnWindowFocus: false,
  });

  useEffect(() => {
    if (data) {
      setUserInfo(Serializer.formatUser(data));
    }
  }, [data, setUserInfo]);

  return userInfo;
};

export default useUserInfo;
